import { GENE, VARIANT, ENTITIES, LOOKUP, IDS } from "../constants/entities";
import { MIN_LOOKUP_LIMIT } from "../constants/constants";

class SourceEntity {
  constructor(data) {
    const { id, symbol, type, count: pubCount, name, pubIds, sourceMap } = data;

    this.id = id || "";
    this.symbol = symbol || "";
    this.type = ENTITIES[type] || "";
    this.name = name || symbol || "";
    this.description = this.name ? `${type}: ${this.name}` : `this ${type}`;
    this.isVariant = this.type === VARIANT;
    this.pubIds = pubIds || [];
    this.sourceMap = sourceMap || new Map();
    this.count = pubIds?.length || pubCount || 0;
    this.data = data;
  }

  setPubIds(pubIds) {
    this.pubIds = pubIds.filter(Boolean);
    return this;
  }

  clone() {
    return new SourceEntity(this.data).setPubIds(this.pubIds);
  }

  getReactionSlugForPub(id) {
    if (this.type !== GENE && this.type !== VARIANT) return null;
    return `${this.type}-${this.id}-publications-${id}`;
  }

  getSlugForContribution(id) {
    if (this.type !== GENE && this.type !== VARIANT) return null;
    return `${this.type}-${this.id}-classifications-${id}`;
  }

  getSlugForComments() {
    if (this.type !== GENE && this.type !== VARIANT) return null;
    return `${this.type}-${this.id}`;
  }

  setLookup(lookupId) {
    this.lookupId = lookupId;
    return this;
  }

  getSourcesForArticle(article) {
    const pubId = String(article.pubmedId);
    const sourceSet = this.sourceMap.get(pubId) || new Set();
    return this.sourceMap.size ? Array.from(sourceSet) : article.sources;
  }

  get searchType() {
    if (this.pubIds?.length > MIN_LOOKUP_LIMIT) return LOOKUP;
    if (this.pubIds?.length > 0) return IDS;
    return this.type;
  }

  get searchTypeId() {
    if (this.pubIds.length > MIN_LOOKUP_LIMIT) {
      return this.lookupId || "";
    }
    if (this.pubIds.length > 0) {
      return this.pubIds.join("~");
    }
    return this.id;
  }

  get relevanceType() {
    if (this.pubIds.length) {
      return this.type;
    }
    return null;
  }

  get relevanceTypeId() {
    if (this.pubIds.length) {
      return this.id;
    }
    return null;
  }
}

export default SourceEntity;
